import React, { useCallback } from 'react';
import { DialogActions, Button } from '@material-ui/core';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import LoadingButton from '~/modules/common/components/LoadingButton';
import { useSnackbar } from '~/modules/common/snackbar';
import { useTaskEstimateRowContext } from '~/modules/tasks/components/TaskDrawer/TaskResourceEstimates/TaskEstimateRowContext';
import useDeleteTaskResourceUserAllocation from './useDeleteTaskResourceUserAllocation';

const RemoveTaskAllocationDialogFooter = ({
  isLoading,
  onClose,
  onRemoveTaskAllocationSuccess,
  updateCache,
  refetchQueries
}) => {
  const { showSnackbar } = useSnackbar();
  const { formatMessage } = useIntl();
  const {
    deleteTaskResourceUserAllocation,
    loading
  } = useDeleteTaskResourceUserAllocation({ updateCache, refetchQueries });

  const {
    task,
    resourceEstimate: { taskResourceUserAllocation }
  } = useTaskEstimateRowContext();

  const onRemoveTaskAllocationSubmit = useCallback(async () => {
    const {
      data: deleteTaskResourceUserAllocationResult
    } = await deleteTaskResourceUserAllocation({
      taskUri: task.id,
      projectUri: task.project.id,
      taskAllocationId: taskResourceUserAllocation?.id
    });

    onRemoveTaskAllocationSuccess({ deleteTaskResourceUserAllocationResult });

    showSnackbar &&
      showSnackbar(
        formatMessage({
          id: 'removeTaskAllocationDialog.snackbarSuccessMessage'
        })
      );
  }, [
    task.id,
    task.project.id,
    taskResourceUserAllocation?.id,
    deleteTaskResourceUserAllocation,
    onRemoveTaskAllocationSuccess,
    formatMessage,
    showSnackbar
  ]);

  return (
    <DialogActions>
      <Button onClick={onClose} autoFocus>
        <FormattedMessage id="removeTaskAllocationDialog.cancel" />
      </Button>
      <LoadingButton
        color="secondary"
        disabled={isLoading}
        isLoading={loading}
        onClick={onRemoveTaskAllocationSubmit}
      >
        <FormattedMessage id="removeTaskAllocationDialog.removeAllocatedTime" />
      </LoadingButton>
    </DialogActions>
  );
};

RemoveTaskAllocationDialogFooter.propTypes = {
  isLoading: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onRemoveTaskAllocationSuccess: PropTypes.func.isRequired,
  updateCache: PropTypes.func,
  refetchQueries: PropTypes.array
};

export default RemoveTaskAllocationDialogFooter;
